import {
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';
import ExplicationResultatsPistesRecommendees from 'components/shared/ExplicationResultatsPistesRecommendees';

const HowAreTheResultsCalculatedModal = ({
  onClose,
  isMobile,
}: {
  onClose: any;
  isMobile?: boolean;
}) => {
  return (
    <>
      <ModalContent maxW={1000} mx={4}>
        <ModalHeader textAlign="center" px={2} mb={0} pb={0}>
          <Text fontSize="3xl"> Comment sont recommandées les pistes ?</Text>
        </ModalHeader>
        <ModalBody>
          <ExplicationResultatsPistesRecommendees isMobile={isMobile} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} {...(isMobile && { width: '100%' })}>
            Fermer
          </Button>
        </ModalFooter>
      </ModalContent>
    </>
  );
};

export default HowAreTheResultsCalculatedModal;
